"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("@mui/material/styles");
/**
 * @ignore - internal component.
 */
var HiSizeSmall = (0, _pure.default)(function (props) {
  var theme = (0, _styles.useTheme)();
  var _props$color = props.color,
    color = _props$color === void 0 ? props.color || theme.palette.neutral.main : _props$color,
    style = props.style,
    other = (0, _objectWithoutProperties2.default)(props, ["color", "style"]);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    style: (0, _objectSpread2.default)({}, style, {
      fontSize: props.size || 24
    })
  }, other), /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M17.4,0.6C17,0.2,16.5,0,16,0H2C1.5,0,1,0.2,0.6,0.6C0.2,1,0,1.5,0,2v14c0,0.6,0.2,1,0.6,1.4 C1,17.8,1.5,18,2,18h14c0.6,0,1-0.2,1.4-0.6C17.8,17,18,16.5,18,16V2C18,1.5,17.8,1,17.4,0.6z M8,7.5c0.3,0.2,0.8,0.4,1.5,0.6 c0.5,0.2,1,0.4,1.4,0.6s0.8,0.4,1,0.7s0.5,0.6,0.6,0.9s0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.3,1.2s-0.4,0.6-0.7,0.9 c-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.9,0.2-1.5,0.2c-0.3,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.1-0.9-0.3s-0.6-0.3-0.8-0.4S6,12.9,5.8,12.7 s-0.3-0.5-0.4-0.8c-0.1-0.3-0.2-0.6-0.2-1h2.1c0,0.3,0,0.6,0.1,0.8s0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.3s0.5,0.1,0.8,0.1 c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.1,0.5-0.2s0.2-0.2,0.3-0.4c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-0.1-0.3-0.3-0.4s-0.3-0.2-0.6-0.3s-0.6-0.2-1-0.4C8.4,9.7,7.9,9.5,7.5,9.3S6.8,8.9,6.5,8.7C6.2,8.4,5.9,8.1,5.8,7.8 S5.5,7.1,5.5,6.7c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.4-0.6,0.8-0.9s0.7-0.4,1.2-0.6C8.1,4,8.6,3.9,9.2,3.9c0.6,0,1.1,0.1,1.5,0.2 c0.5,0.2,0.8,0.4,1.2,0.6s0.6,0.6,0.7,1c0.2,0.4,0.3,0.8,0.3,1.2h-2.1c0-0.2,0-0.4-0.1-0.6s-0.2-0.3-0.3-0.5s-0.3-0.2-0.5-0.3 C9.6,5.6,9.4,5.5,9.1,5.5c-0.3,0-0.5,0-0.7,0.1S8.1,5.8,7.9,5.9S7.7,6.1,7.6,6.2S7.5,6.5,7.5,6.7C7.5,7,7.7,7.3,8,7.5z",
    fill: color
  })));
});
HiSizeSmall.muiName = 'SvgIcon';
var _default = exports.default = HiSizeSmall;